module.exports = __webpack_public_path__ + "static/media/image84.5a8b39f0.png";